import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortBySerialnumber' })
export class SortBySerialnumberPipe implements PipeTransform {
  transform(installations: any[], ...args: unknown[]): any[] {
    if (installations) {
      return installations.sort((c1, c2) => {
        if (c1.serialNumber > c2.serialNumber) {
          return 1;
        }

        if (c1.serialNumber < c2.serialNumber) {
          return -1;
        }

        return 0;
      });
    }
    return installations;
  }
}
